import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

const timeInterval = 100;
const removeTimeInterval = 5000;

@Injectable({
  providedIn: 'root'
})
export class BaseOptimizeService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object){}

  private keysMap: Map<string, { lastValue: boolean, observable: BehaviorSubject<boolean> }> = new Map();
  private setIntervalReferenceMap: Map<string, any> = new Map<string, any>();

  public register(key: string): void {
    if (this.keysMap.has(key)) {
      return;
    }

    this.keysMap.set(key, { lastValue: false, observable: new BehaviorSubject<boolean>(false) });
    if (isPlatformBrowser(this.platformId)) {
      this.startTracking(key);
    }
  }

  public get(key: string): Observable<boolean> {
    if (this.keysMap.has(key)) {
      return this.keysMap.get(key).observable.asObservable();
    }

    return of(false);
  }

  private startTracking(key: string): void {
    // Watching window.{key} variables value
    // which sets by Google optimize, we will watch for the first 5 secs by keep checking this value every 200 ms
    this.setIntervalReferenceMap.set(key, setInterval(() => {
      const windowVariableValue = !!window[key];
      if (this.keysMap.get(key).lastValue !== windowVariableValue) {
        this.keysMap.get(key).lastValue = windowVariableValue;
        this.keysMap.get(key).observable.next(windowVariableValue);
        this.stopTracking(key);
      }
    }, timeInterval));

    setTimeout(() => {
      this.stopTracking(key);
    }, removeTimeInterval);
  }

  private stopTracking(key: string): void {
    if (!this.setIntervalReferenceMap.has(key)) {
      return;
    }

    clearInterval(this.setIntervalReferenceMap.get(key));
    this.setIntervalReferenceMap.delete(key);
  }

}
